import React, { useMemo, useContext } from 'react';

import { ITipSettingsProvider, LoadingIndicator, ITipOptions } from './type';
import { fetchTipConfiguration, putTipConfiguration } from './http';

const TipSettings = React.createContext<ITipSettingsProvider>({} as any);
export const TipSettingsProvider = ({ children }: { children: any }) => {
  const [tipToggle, updateTipToggle] = React.useState(false);
  const [tipOptions, updateTipOptions] = React.useState<ITipOptions>({
    option1: 0,
    option2: 0,
    option3: 0,
  });
  const [loadingState, setLoadingState] = React.useState(LoadingIndicator.pending);

  React.useEffect(() => {
    let isMounted = true;

    const fetchConfig = async () => {
      try {
        const { tipToggle, tipOptions } = await fetchTipConfiguration();
        updateTipToggle(tipToggle);
        updateTipOptions(tipOptions);
        setLoadingState(LoadingIndicator.completed);
      } catch (e) {
        if (isMounted) {
          setLoadingState(LoadingIndicator.error);
        }
      }
    };

    fetchConfig();
    return () => {
      isMounted = false;
    };
  }, []);

  const updateTipConfiguration = React.useCallback(
    async ({ tipToggle: internalTipToggle, tipOptions: internalTipOptions }) => {
      const { tipToggle: newTipToggle, tipOptions: newTipOptions } = await putTipConfiguration({
        tipToggle: internalTipToggle,
        tipOptions: internalTipOptions,
      });

      updateTipToggle(newTipToggle);
      updateTipOptions(newTipOptions);
    },
    []
  );

  const props = useMemo(() => {
    return {
      tipToggle,
      tipOptions,
      updateTipToggle,
      loadingState,
      updateTipConfiguration,
    };
  }, [loadingState, tipOptions, tipToggle, updateTipConfiguration]);

  return <TipSettings.Provider value={props}>{children}</TipSettings.Provider>;
};

export const useTipSettings = () => {
  return useContext(TipSettings);
};
